import React from "react";
import { TemplatesLibraryPageStyled } from "./styled";
//import { Templates } from "templates-library-package";
import { inject } from "mobx-react";
import Api from "../../../services/Api";
import Templates from "../../Templates/Templates/Templates";
import TemplatesStore from "../../../stores/templatesStore";

type Props = {
  api?: Api;
  templatesStore?: TemplatesStore;
};

@inject("api", "templatesStore")
class TemplatesLibraryPage extends React.PureComponent<Props, any> {
  
  componentDidMount = async () => {
    await this.props?.api?.getTemplates();
  };

  api = {
    getTemplates: () => {
      console.log("getTemplates");
      return {
        data: {
          templates: [
            {
              name: "",
              json: {}
            }
          ]
        },
        status: 200
      };
    }
  };

  render() {
    return (
      <TemplatesLibraryPageStyled>
        <Templates
          templatesStore={this.props.templatesStore}
          // api={this.api}
          // currentPage={1}
          // onDisplayNew={()=>{}}
          // onDisplayEdit={()=>{}}
          // onClone={() => {}}
          // onDelete={() => {}}
          // onPageSettingsChange={() => {}}
        />
      </TemplatesLibraryPageStyled>
    );
  }
}
export default TemplatesLibraryPage;
